import { render, staticRenderFns, recyclableRender, components } from "./chose-city.vue?vue&type=template&id=6df34019&scoped=true&"
var renderjs
import script from "./chose-city.vue?vue&type=script&lang=js&"
export * from "./chose-city.vue?vue&type=script&lang=js&"
import style0 from "./chose-city.vue?vue&type=style&index=0&id=6df34019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df34019",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages2/components/chose-city/chose-city.vue"
export default component.exports